import { FormInput } from "../../../../../../components/ui/Input/FormInput/FormInput";
import { FormInputNumber } from "../../../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormUnitInput } from "../../../../../../components/ui/Input/FormUnitInput/FormUnitInput";
import { WEIGHT_UNIT_TYPES_OPTIONs } from "../../../../../../config/optionsConstants";
import { validateExternalTransport, valueGraterThanZero } from "../../../../../../utils/utils";
import { ExternalTransportSectionProps } from "../externalTransport.types";

interface ExternalTransportRouteSectionProps extends ExternalTransportSectionProps {
  weightDisabled?: boolean;
  distanceDisabled?: boolean;
}

const ExternalTransportRouteSection = ({
  control,
  disabled,
  weightDisabled = false,
  distanceDisabled = false
}: ExternalTransportRouteSectionProps) => (
  <div className="tw-space-y-4">
    <div className="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-4 md:tw-grid-cols-2">
      <FormInput
        control={control}
        name="from"
        label="From"
        placeholder="Origin"
        disabled={disabled}
      />
      <FormInput
        control={control}
        name="to"
        label="To"
        placeholder="Destination"
        disabled={disabled}
      />
    </div>
    <div className="tw-grid tw-grid-cols-1 tw-gap-x-4 tw-gap-y-4 md:tw-grid-cols-2">
      <FormInputNumber
        control={control}
        name="distance"
        label="Distance (km)"
        placeholder="0"
        required
        disabled={disabled || distanceDisabled}
        errorMessage="Distance is required"
        rules={{
          validate: {
            validateNumber: (v: unknown) => validateExternalTransport(v),
            valueCheckGraterThanZero: (v: unknown) =>
              valueGraterThanZero(v) || "Distance must be greater than zero"
          }
        }}
      />
      <FormUnitInput
        control={control}
        name="weight"
        unitName="weightUnit"
        label="Weight"
        placeholder="0"
        required
        disabled={disabled || weightDisabled}
        errorMessage="Weight is required"
        unitOptions={WEIGHT_UNIT_TYPES_OPTIONs}
        validate={{
          validateNumber: (v: unknown) => validateExternalTransport(v),
          valueCheckGraterThanZero: (v: unknown) =>
            valueGraterThanZero(v) || "Weight must be greater than zero"
        }}
      />
    </div>
  </div>
);

export default ExternalTransportRouteSection;
